import React from 'react';

const AccountDeletion = () => {
    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
            <h1>Eliminación de Cuenta y Datos</h1>
            <p><strong>Fecha de vigencia:</strong> 11/08/2025</p>

            <h2>1. Introducción</h2>
            <p>
                En <strong>Esmibar</strong>, respetamos tu privacidad y te ofrecemos la posibilidad de
                eliminar tu cuenta y los datos asociados en cualquier momento. Esta página explica cómo
                solicitar la eliminación, qué datos se eliminan y cuáles se conservan según la ley.
            </p>

            <h2>2. Cómo Solicitar la Eliminación</h2>
            <p>Puedes solicitar la eliminación de tu cuenta de dos formas:</p>
            <ul>
                <li>
                    <strong>Desde la App:</strong> Inicia sesión en la aplicación, ve a
                    <em> Configuración → Privacidad → Eliminar cuenta</em> y sigue las instrucciones.
                </li>
                <li>
                    <strong>Por correo electrónico:</strong> Envía un email a
                    <a href="mailto:esmibar.adm@gmail.com"> esmibar.adm@gmail.com</a>
                    con el asunto <em>"Solicitud de eliminación de cuenta"</em>, incluyendo el correo registrado.
                </li>
            </ul>

            <h2>3. Datos que se Eliminarán</h2>
            <p>Al procesar tu solicitud, eliminaremos de forma permanente:</p>
            <ul>
                <li>Información personal (nombre, correo electrónico, foto de perfil).</li>
                <li>Historial de preferencias, filtros y configuraciones.</li>
                <li>Datos de uso asociados a tu cuenta.</li>
            </ul>

            <h2>4. Datos que se Conservarán</h2>
            <p>Por motivos legales y de seguridad, conservaremos los siguientes datos por el tiempo requerido:</p>
            <ul>
                <li>Registros de facturación y transacciones: <strong>5 años</strong> (requerido por ley).</li>
                <li>Registros de seguridad y auditoría: <strong>12 meses</strong> (para prevenir fraudes y cumplir normativas).</li>
            </ul>

            <h2>5. Plazo de Eliminación</h2>
            <p>
                La eliminación completa de tu información personal se realizará en un plazo máximo de
                <strong> 30 días</strong> desde la confirmación de tu solicitud, salvo las excepciones legales mencionadas.
            </p>

            <h2>6. Consecuencias de la Eliminación</h2>
            <p>
                Una vez que tu cuenta sea eliminada, no podrás recuperar ningún dato, y perderás acceso a todos
                los servicios y beneficios asociados a tu cuenta en Esmibar.
            </p>

            <h2>7. Contacto</h2>
            <p>
                Si tienes dudas sobre el proceso de eliminación de cuenta o datos, contáctanos:
            </p>
            <p>Email: <a href="mailto:esmibar.adm@gmail.com">esmibar.adm@gmail.com</a></p>
        </div>
    );
};

export default AccountDeletion;
